import { securedAppApi } from "./securedApi";
const CREATE_ROLE = '/identity/role';
const GET_ROLE_PERMISSIONS = '/identity/role/permissions';
const UPDATE_MANAGE_ROLES = 'identity/user/roles';
const ADD_UPDATE_PERMISSIONS = 'identity/role/permissions/update';
const GET_AGREEMENT_INVOLVED_ROLE = '/agreementinvolvedpartyrole';
const GET_AGREEMENT_LIFE_CYCLE = 'AgreementLifeCycleStatus';
const GET_INDIVIDUAL_IDENTIFICATION = '/IndividualIdentificationType';
const GET_INDIVIDUAL_PARTY_CYCLE = '/InvolvedPartyLifeCycleStatus';
const GET_INVOLVED_PARTY_ROLE = '/involvedpartyrole';
const GET_PROJECT_WORKROLES = 'TeamMemberLookUp/ProjectWorkRole';
const GET_PACKAGE_ACTIVITY_STATUS = '/packageactivitystatus';
const GET_PACKAGE_ASSIGNMENT = '/packageassignmentroletype';
const GET_PACKAGE_LIFE_CYCLE = '/packagelifecyclestatus';
const GET_ROLES_DROPDOWN = 'v1/individuals/GetAllInvolvedPartyRoles';
const GET_EDUCATION_LOOKUP = 'TeamMemberLookUp/EducationalCourseType';
const GET_OPERATION_LOCATION = 'TeamMemberLookUp/OperationalLocation';
const GET_PROJECTWORK_TYPEMETHODOLOGY = 'TeamMemberLookUp/ProjectWorkTypeMethodology';
const GET_REFERERENCES_ENUMERATION_TABLE = 'References/EnumerationTables';
const GET_ADD_POST_DELETE_PROJECT_ITEM_TYPE = 'References/ProjectItemType';
const GET_WORK_ITEM_LEVEL = 'References/WorkItemLevel'
const GET_WORK_ITEM_LEVELBY_WORKITEMTYPEID = 'References/WorkItemLevelsByWorkItemTypeId'
const GET_ORGANIZATION = '/v1/Organizations';
const GET_USERS_ROLES = 'identity/user/roles';
const POST_USERS_ROLES = 'identity/user/roles';
const PTO_ACCRUAL_FREQUENCY = 'References/PTOAccrualFrequency';
const GET_PUBLICHOLIDAY = 'References/PublicHoliday';
const GET_EMAIL_TEMPLATE_VARIABLE = 'References/EmailTemplateVariable';
const GET_EMAIL_TEMPLATE_VARIABLE_GROUP = 'References/EmailTemplateVariableGroup';
const GET_EMAIL_TEMPLATE_VARIABLE_MAPPING = 'References/EmailTemplateVariableMapping';
const GET_EMAIL_TEMPLATE_MODULE_VARIABLE_GROUP = 'References/EmailTemplateModuleVariableGroup';
const GET_FUNCTIONAL_MODULE = 'References/FunctionalModule';
const GET_USERROLERELATION = 'UserRoleRelation/UserRoleRelation';
const GET_All_CALENDAR_YEAR = 'References/CalendarYear';
const CALENDAR_YEAR = 'References/CalendarYear';


const rolesApiHandler = securedAppApi.injectEndpoints({
  endpoints: (builder) => ({
    getrole: builder.query({
      query: () =>
        CREATE_ROLE,
    }),
    addRoles: builder.mutation({
      query: (ProfileSignatures) => ({
        url: CREATE_ROLE,
        method: 'POST',
        body: ProfileSignatures,
      }),
    }),
    deleteRoles: builder.mutation({
      query: (RoleId) => ({
        url: `${CREATE_ROLE}/${RoleId}`,
        method: 'DELETE',
      }),
    }),
    GetRolePermissions: builder.query({
      query: ({ id }) =>
        GET_ROLE_PERMISSIONS + `/${id}`,
    }),
    updateManageRoles: builder.mutation({
      query: (ProfileSignatures) => ({
        url: UPDATE_MANAGE_ROLES + `/${ProfileSignatures?.id}`,
        method: 'PUT',
        body: ProfileSignatures,
      }),
    }),
    addPermissions: builder.mutation({
      query: (permissions) => ({
        url: ADD_UPDATE_PERMISSIONS,
        method: 'PUT',
        body: permissions,
      }),
    }),
    getAgreementInvolved: builder.query({
      query: ({ pageNumber, pageSize, searchString }) =>
        GET_AGREEMENT_INVOLVED_ROLE + `?pageNumber=${pageNumber}&pageSize=${pageSize}&searchString=${searchString}`
    }),
    getAgreementLifeCycle: builder.query({
      query: ({ pageNumber, pageSize, searchString }) =>
        GET_AGREEMENT_LIFE_CYCLE + `?pageNumber=${pageNumber}&pageSize=${pageSize}&searchString=${searchString}`
    }),
    getIndividualIdentification: builder.query({
      query: ({ pageNumber, pageSize, searchString }) =>
        GET_INDIVIDUAL_IDENTIFICATION + `?pageNumber=${pageNumber}&pageSize=${pageSize}&searchString=${searchString}`
    }),

    getInvolvedPartyCycle: builder.query({
      query: ({ pageNumber, pageSize, searchString }) =>
        GET_INDIVIDUAL_PARTY_CYCLE + `?pageNumber=${pageNumber}&pageSize=${pageSize}&searchString=${searchString}`
    }),
    getInvolvedPartyRole: builder.query({
      query: ({ pageNumber, pageSize, searchString }) =>
        GET_INVOLVED_PARTY_ROLE + `?pageNumber=${pageNumber}&pageSize=${pageSize}&searchString=${searchString}`
    }),

    getPackageActivityStatus: builder.query({
      query: ({ pageNumber, pageSize, searchString }) =>
        GET_PACKAGE_ACTIVITY_STATUS + `?pageNumber=${pageNumber}&pageSize=${pageSize}&searchString=${searchString}`
    }),
    getPackageAssignment: builder.query({
      query: ({ pageNumber, pageSize, searchString }) =>
        GET_PACKAGE_ASSIGNMENT + `?pageNumber=${pageNumber}&pageSize=${pageSize}&searchString=${searchString}`
    }),
    getPackageLifeCycle: builder.query({
      query: ({ pageNumber, pageSize, searchString }) =>
        GET_PACKAGE_LIFE_CYCLE + `?pageNumber=${pageNumber}&pageSize=${pageSize}&searchString=${searchString}`
    }),
    AddAgreementInvolved: builder.mutation({
      query: (permissions) => ({
        url: GET_AGREEMENT_INVOLVED_ROLE,
        method: 'POST',
        body: permissions,
      }),
    }),
    DeleteAgreementInvolved: builder.mutation({
      query: (RoleId) => ({
        url: `${GET_AGREEMENT_INVOLVED_ROLE}/${RoleId}`,
        method: 'DELETE',
      }),
    }),
    AddAgreementLifeCycle: builder.mutation({
      query: (permissions) => ({
        url: GET_AGREEMENT_LIFE_CYCLE,
        method: 'POST',
        body: permissions,
      }),
    }),
    DeleteAgreementLifrCycle: builder.mutation({
      query: (RoleId) => ({
        url: `${GET_AGREEMENT_LIFE_CYCLE}/${RoleId}`,
        method: 'DELETE',
      }),
    }),
    AddProjectWorkRole: builder.mutation({
      query: (permissions) => ({
        url: GET_PROJECT_WORKROLES,
        method: 'POST',
        body: permissions,
      }),
    }),
    DeleteProjectWorkRole: builder.mutation({
      query: (EligibleId) => ({
        url: `${GET_PROJECT_WORKROLES}/${EligibleId}`,
        method: 'DELETE',
      }),
    }),
    GetProjectWorkRole: builder.query({
      query: ({ pageNumber, pageSize, searchString }) =>
        GET_PROJECT_WORKROLES + `?pageNumber=${pageNumber}&pageSize=${pageSize}&searchString=${searchString}`
    }),
    AddIndividualIdentification: builder.mutation({
      query: (permissions) => ({
        url: GET_INDIVIDUAL_IDENTIFICATION,
        method: 'POST',
        body: permissions,
      }),
    }),
    DeleteIndividualIdentification: builder.mutation({
      query: (RoleId) => ({
        url: `${GET_INDIVIDUAL_IDENTIFICATION}/${RoleId}`,
        method: 'DELETE',
      }),
    }),
    AddInvolvedPartyLifeCycle: builder.mutation({
      query: (permissions) => ({
        url: GET_INDIVIDUAL_PARTY_CYCLE,
        method: 'POST',
        body: permissions,
      }),
    }),
    DeleteInvolvedPartyLifeCycle: builder.mutation({
      query: (RoleId) => ({
        url: `${GET_INDIVIDUAL_IDENTIFICATION}/${RoleId}`,
        method: 'DELETE',
      }),
    }),
    AddInvolvedPartyRole: builder.mutation({
      query: (permissions) => ({
        url: GET_INVOLVED_PARTY_ROLE,
        method: 'POST',
        body: permissions,
      }),
    }),
    AddPackageActivityStatus: builder.mutation({
      query: (permissions) => ({
        url: GET_PACKAGE_ACTIVITY_STATUS,
        method: 'POST',
        body: permissions,
      }),
    }),
    AddPackageAssignmentTypes: builder.mutation({
      query: (permissions) => ({
        url: GET_PACKAGE_ASSIGNMENT,
        method: 'POST',
        body: permissions,
      }),
    }),
    AddPackageLifeCycles: builder.mutation({
      query: (permissions) => ({
        url: GET_PACKAGE_LIFE_CYCLE,
        method: 'POST',
        body: permissions,
      }),
    }),
    DeleteIndividualIdentificationType: builder.mutation({
      query: (RoleId) => ({
        url: `${GET_INDIVIDUAL_IDENTIFICATION}/${RoleId}`,
        method: 'DELETE',
      }),
    }),
    DeletePartyLifeCycle: builder.mutation({
      query: (RoleId) => ({
        url: `${GET_INDIVIDUAL_PARTY_CYCLE}/${RoleId}`,
        method: 'DELETE',
      }),
    }),
    DeletePartyRole: builder.mutation({
      query: (RoleId) => ({
        url: `${GET_INVOLVED_PARTY_ROLE}/${RoleId}`,
        method: 'DELETE',
      }),
    }),
    DeletePackageActivity: builder.mutation({
      query: (RoleId) => ({
        url: `${GET_PACKAGE_ACTIVITY_STATUS}/${RoleId}`,
        method: 'DELETE',
      }),
    }),
    DeletePackageAssignment: builder.mutation({
      query: (RoleId) => ({
        url: `${GET_PACKAGE_ASSIGNMENT}/${RoleId}`,
        method: 'DELETE',
      }),
    }),
    DeletePackageLifeCycle: builder.mutation({
      query: (RoleId) => ({
        url: `${GET_PACKAGE_LIFE_CYCLE}/${RoleId}`,
        method: 'DELETE',
      }),
    }),
    GetRolesDropdown: builder.query({
      query: () =>
        GET_ROLES_DROPDOWN
    }),
    GetEducationLookup: builder.query({
      query: ({ pageNumber, pageSize, searchString }) =>
        GET_EDUCATION_LOOKUP + `?pageNumber=${pageNumber}&pageSize=${pageSize}&searchString=${searchString}`
    }),
    AddEducationLookup: builder.mutation({
      query: (permissions) => ({
        url: GET_EDUCATION_LOOKUP,
        method: 'POST',
        body: permissions,
      }),
    }),
    DeleteEducationLookup: builder.mutation({
      query: (RoleId) => ({
        url: `${GET_EDUCATION_LOOKUP}/${RoleId}`,
        method: 'DELETE',
      }),
    }),

    AddPublicHoliday: builder.mutation({
      query: (permissions) => ({
        url: GET_PUBLICHOLIDAY,
        method: 'POST',
        body: permissions,
      }),
    }),
    DeletePublicHoliday: builder.mutation({
      query: (PublicHolidayId) => ({
        url: `${GET_PUBLICHOLIDAY}/${PublicHolidayId}`,
        method: 'DELETE',
      }),
    }),
    GetPublicHoliday: builder.query({
      query: ({ pageNumber, pageSize, searchString, locationId, year }) =>
        GET_PUBLICHOLIDAY + `?pageNumber=${pageNumber}&pageSize=${pageSize}&searchString=${searchString}&locationId=${locationId}&year=${year}`
    }),
    AddOperational: builder.mutation({
      query: (permissions) => ({
        url: GET_OPERATION_LOCATION,
        method: 'POST',
        body: permissions,
      }),
    }),
    DeleteOperational: builder.mutation({
      query: (EligibleId) => ({
        url: `${GET_OPERATION_LOCATION}/${EligibleId}`,
        method: 'DELETE',
      }),
    }),
    GetOperational: builder.query({
      query: ({ pageNumber, pageSize, searchString }) =>
        GET_OPERATION_LOCATION + `?pageNumber=${pageNumber}&pageSize=${pageSize}&searchString=${searchString}`
    }),
    AddWorkItemLevel: builder.mutation({
      query: (permissions) => ({
        url: GET_WORK_ITEM_LEVEL,
        method: 'POST',
        body: permissions,
      }),
    }),
    DeleteWorkItemLevel: builder.mutation({
      query: (WorkItemLevelId) => ({
        url: `${GET_WORK_ITEM_LEVEL}/${WorkItemLevelId}`,
        method: 'DELETE',
      }),
    }),
    GetWorkItemLevel: builder.query({
      query: ({ pageNumber, pageSize, searchString }) =>
        GET_WORK_ITEM_LEVEL + `?pageNumber=${pageNumber}&pageSize=${pageSize}&searchString=${searchString}`
    }),
    GetWorkItemLevelByWorkItemTypeId: builder.query({
      query: ({ WorkItemTypeId }) =>
        GET_WORK_ITEM_LEVELBY_WORKITEMTYPEID + `/${WorkItemTypeId}`
    }),
    AddProjectMethodology: builder.mutation({
      query: (permissions) => ({
        url: GET_PROJECTWORK_TYPEMETHODOLOGY,
        method: 'POST',
        body: permissions,
      }),
    }),
    DeleteProjectMethods: builder.mutation({
      query: (EligibleId) => ({
        url: `${GET_PROJECTWORK_TYPEMETHODOLOGY}/${EligibleId}`,
        method: 'DELETE',
      }),
    }),
    GetProjectMethods: builder.query({
      query: ({ pageNumber, pageSize, searchString }) =>
        GET_PROJECTWORK_TYPEMETHODOLOGY + `?pageNumber=${pageNumber}&pageSize=${pageSize}&searchString=${searchString}`
    }),

    GetEnumerationTables: builder.query({
      query: ({ pageNumber, pageSize, searchString }) =>
        GET_REFERERENCES_ENUMERATION_TABLE + `?pageNumber=${pageNumber}&pageSize=${pageSize}&searchString=${searchString}`
    }),
    AddEnumerationTable: builder.mutation({
      query: (permissions) => ({
        url: GET_REFERERENCES_ENUMERATION_TABLE,
        method: 'POST',
        body: permissions,
      }),
    }),
    DeleteEnumerationTable: builder.mutation({
      query: (Id) => ({
        url: `${GET_REFERERENCES_ENUMERATION_TABLE}/${Id}`,
        method: 'DELETE',
      }),
    }),
    GetProjectItemType: builder.query({
      query: ({ pageNumber, pageSize, searchString }) =>
        GET_ADD_POST_DELETE_PROJECT_ITEM_TYPE + `?pageNumber=${pageNumber}&pageSize=${pageSize}&searchString=${searchString}`
    }),
    AddProjectItemType: builder.mutation({
      query: (permissions) => ({
        url: GET_ADD_POST_DELETE_PROJECT_ITEM_TYPE,
        method: 'POST',
        body: permissions,
      }),
    }),
    DeleteProjectItemType: builder.mutation({
      query: (EligibleId) => ({
        url: `${GET_ADD_POST_DELETE_PROJECT_ITEM_TYPE}/${EligibleId}`,
        method: 'DELETE',
      }),
    }),

    // GetOrganizationList: builder.query({
    //   query: ({ pageNumber, pageSize, searchString, orderBy, IsActive }) =>
    //     GET_ORGANIZATION + `?pageNumber=${pageNumber}&pageSize=${pageSize}&searchString=${searchString}&orderBy=${orderBy}&IsActive=${IsActive}`,
    // }),
    GetOrganizationList: builder.query({
      query: ({ pageNumber, pageSize, searchString, orderBy, IsActive }) => {
        // Only include IsActive if it is defined
        const isActiveParam = IsActive !== undefined && IsActive !== null ? `&IsActive=${IsActive}` : '';

        return GET_ORGANIZATION +
          `?pageNumber=${pageNumber}&pageSize=${pageSize}&searchString=${searchString}&orderBy=${orderBy || ''}${isActiveParam}`;
      },
    }),
    GetUserRoles: builder.query({
      query: ({ id }) =>
        GET_USERS_ROLES + `/${id}`
    }),

    AddUserRoles: builder.mutation({
      query: (data) => ({
        url: POST_USERS_ROLES + `/${data?.userId}`,
        method: 'PUT',
        body: data,
      }),
    }),

    GetPTOAccrualFrequency: builder.query({
      query: ({ pageNumber, pageSize, searchString }) =>
        PTO_ACCRUAL_FREQUENCY + `?pageNumber=${pageNumber}&pageSize=${pageSize}&searchString=${searchString}`
    }),

    addPTOAccrualFrequency: builder.mutation({
      query: (permissions) => ({
        url: PTO_ACCRUAL_FREQUENCY,
        method: 'POST',
        body: permissions,
      }),
    }),

    DeletePTOAccrualFrequency: builder.mutation({
      query: (id) => ({
        url: `${PTO_ACCRUAL_FREQUENCY}/${id}`,
        method: 'DELETE',
      }),
    }),

    AddEmailTemplateVariable: builder.mutation({
      query: (permissions) => ({
        url: GET_EMAIL_TEMPLATE_VARIABLE,
        method: 'POST',
        body: permissions,
      }),
    }),
    DeleteEmailTemplateVariable: builder.mutation({
      query: (CodeId) => ({
        url: `${GET_EMAIL_TEMPLATE_VARIABLE}/${CodeId}`,
        method: 'DELETE',
      }),
    }),
    GetAllEmailTempalteVariable: builder.query({
      query: ({ pageNumber, pageSize, searchString, CodeSchemeId }) =>
        GET_EMAIL_TEMPLATE_VARIABLE + `?pageNumber=${pageNumber}&pageSize=${pageSize}&searchString=${searchString}&CodeSchemeId=${CodeSchemeId}`
    }),

    AddEmailTemplateVariableGroup: builder.mutation({
      query: (permissions) => ({
        url: GET_EMAIL_TEMPLATE_VARIABLE_GROUP,
        method: 'POST',
        body: permissions,
      }),
    }),
    DeleteEmailTemplateVariableGroup: builder.mutation({
      query: (CodeId) => ({
        url: `${GET_EMAIL_TEMPLATE_VARIABLE_GROUP}/${CodeId}`,
        method: 'DELETE',
      }),
    }),
    GetAllEmailTempalteVariableGroup: builder.query({
      query: ({ pageNumber, pageSize, searchString, CodeSchemeId }) =>
        GET_EMAIL_TEMPLATE_VARIABLE_GROUP + `?pageNumber=${pageNumber}&pageSize=${pageSize}&searchString=${searchString}&CodeSchemeId=${CodeSchemeId}`
    }),

    AddEmailTemplateVariableMapping: builder.mutation({
      query: (permissions) => ({
        url: GET_EMAIL_TEMPLATE_VARIABLE_MAPPING,
        method: 'POST',
        body: permissions,
      }),
    }),
    DeleteEmailTemplateVariableMapping: builder.mutation({
      query: (CodeId) => ({
        url: `${GET_EMAIL_TEMPLATE_VARIABLE_MAPPING}/${CodeId}`,
        method: 'DELETE',
      }),
    }),
    GetAllEmailTempalteVariableMapping: builder.query({
      query: ({ pageNumber, pageSize, searchString, CodeSchemeId }) =>
        GET_EMAIL_TEMPLATE_VARIABLE_MAPPING + `?pageNumber=${pageNumber}&pageSize=${pageSize}&searchString=${searchString}&CodeSchemeId=${CodeSchemeId}`
    }),
    AddEmailTemplateModuleVariableGroup: builder.mutation({
      query: (permissions) => ({
        url: GET_EMAIL_TEMPLATE_MODULE_VARIABLE_GROUP,
        method: 'POST',
        body: permissions,
      }),
    }),
    DeleteEmailTemplateModuleVariableGroup: builder.mutation({
      query: (CodeId) => ({
        url: `${GET_EMAIL_TEMPLATE_MODULE_VARIABLE_GROUP}/${CodeId}`,
        method: 'DELETE',
      }),
    }),
    GetAllEmailTemplateModuleVariableGroup: builder.query({
      query: ({ pageNumber, pageSize, searchString, CodeSchemeId }) =>
        GET_EMAIL_TEMPLATE_MODULE_VARIABLE_GROUP + `?pageNumber=${pageNumber}&pageSize=${pageSize}&searchString=${searchString}&CodeSchemeId=${CodeSchemeId}`
    }),
    AddFunctionalModule: builder.mutation({
      query: (permissions) => ({
        url: GET_FUNCTIONAL_MODULE,
        method: 'POST',
        body: permissions,
      }),
    }),
    DeleteFunctionalModule: builder.mutation({
      query: (Id) => ({
        url: `${GET_FUNCTIONAL_MODULE}/${Id}`,
        method: 'DELETE',
      }),
    }),
    GetAllFunctionalModule: builder.query({
      query: ({ pageNumber, pageSize, searchString }) =>
        GET_FUNCTIONAL_MODULE + `?pageNumber=${pageNumber}&pageSize=${pageSize}&searchString=${searchString}`
    }),

    GetUserRoleRelation: builder.query({
      query: ({ userId, pageNumber = 1, pageSize = 10 }) =>
        `${GET_USERROLERELATION}?userId=${userId}&pageNumber=${pageNumber}&pageSize=${pageSize}`,
    }),

    AddEditUserRoleRelation: builder.mutation({
      query: (data) => ({
        url: GET_USERROLERELATION,
        method: 'POST',
        body: data,
      }),
    }),
    DeleteUserRoleRelation: builder.mutation({
      query: (id) => ({
        url: `${GET_USERROLERELATION}/${id}`,
        method: 'DELETE',
      }),
    }),
    AddEditCalendarYear: builder.mutation({
      query: (data) => ({
        url: CALENDAR_YEAR,
        method: 'POST',
        body: data,
      }),
    }),
    GetAllCalendarYear: builder.query({
      query: (params) => {
        const queryParams = new URLSearchParams();
        if (params?.pageNumber !== undefined) {
          queryParams.append('pageNumber', params.pageNumber.toString());
        }
        if (params?.pageSize !== undefined) {
          queryParams.append('pageSize', params.pageSize.toString());
        }
        if (params?.searchString) {
          queryParams.append('searchString', params.searchString);
        }
        return `${GET_All_CALENDAR_YEAR}?${queryParams.toString()}`;
      }
    }),
  })
})

export const { useGetroleQuery, useAddRolesMutation, useDeleteRolesMutation, useGetRolePermissionsQuery, useUpdateManageRolesMutation,
  useAddPermissionsMutation, useGetAgreementInvolvedQuery, useGetAgreementLifeCycleQuery, useGetIndividualIdentificationQuery,
  useGetInvolvedPartyCycleQuery, useGetInvolvedPartyRoleQuery, useGetPackageActivityStatusQuery, useGetPackageAssignmentQuery
  , useGetPackageLifeCycleQuery, useAddAgreementInvolvedMutation, useDeleteAgreementInvolvedMutation, useAddAgreementLifeCycleMutation, useDeleteAgreementLifrCycleMutation,
  useAddIndividualIdentificationMutation, useDeleteIndividualIdentificationMutation, useAddInvolvedPartyLifeCycleMutation, useDeleteInvolvedPartyLifeCycleMutation,
  useAddInvolvedPartyRoleMutation, useAddPackageActivityStatusMutation, useAddPackageAssignmentTypesMutation, useAddPackageLifeCyclesMutation,
  useDeleteIndividualIdentificationTypeMutation, useDeletePartyLifeCycleMutation, useDeletePartyRoleMutation, useDeletePackageActivityMutation
  , useDeletePackageAssignmentMutation, useDeletePackageLifeCycleMutation, useGetRolesDropdownQuery,
  useGetEducationLookupQuery, useAddEducationLookupMutation, useDeleteEducationLookupMutation,
  useAddPublicHolidayMutation, useGetPublicHolidayQuery, useDeletePublicHolidayMutation,
  useAddOperationalMutation, useAddProjectWorkRoleMutation, useGetProjectWorkRoleQuery, useDeleteProjectWorkRoleMutation,
  useGetOperationalQuery, useDeleteOperationalMutation, useAddProjectMethodologyMutation, useGetProjectMethodsQuery, useDeleteProjectMethodsMutation,
  useGetEnumerationTablesQuery, useGetProjectItemTypeQuery, useAddProjectItemTypeMutation, useDeleteProjectItemTypeMutation, useAddWorkItemLevelMutation, useGetWorkItemLevelQuery, useDeleteWorkItemLevelMutation, useGetWorkItemLevelByWorkItemTypeIdQuery, useGetOrganizationListQuery,
  useAddEnumerationTableMutation, useDeleteEnumerationTableMutation, useGetUserRolesQuery, useAddUserRolesMutation, useAddPTOAccrualFrequencyMutation, useDeletePTOAccrualFrequencyMutation,
  useGetPTOAccrualFrequencyQuery, useAddEmailTemplateVariableMutation, useGetAllEmailTempalteVariableQuery, useDeleteEmailTemplateVariableMutation,
  useAddEmailTemplateVariableGroupMutation, useGetAllEmailTempalteVariableGroupQuery, useDeleteEmailTemplateVariableGroupMutation,
  useAddEmailTemplateVariableMappingMutation, useGetAllEmailTempalteVariableMappingQuery, useDeleteEmailTemplateVariableMappingMutation,
  useAddEmailTemplateModuleVariableGroupMutation, useGetAllEmailTemplateModuleVariableGroupQuery, useDeleteEmailTemplateModuleVariableGroupMutation,
  useAddFunctionalModuleMutation, useGetAllFunctionalModuleQuery, useDeleteFunctionalModuleMutation, useGetUserRoleRelationQuery, useAddEditUserRoleRelationMutation, useDeleteUserRoleRelationMutation,
  useAddEditCalendarYearMutation, useGetAllCalendarYearQuery
} = rolesApiHandler;
export default rolesApiHandler.reducer;
